import Mood from './Life Meters/Mood'
import Temperature from './Life Meters/Temperature'
import SleepSwitch from './Life Meters/SleepSwitch'
import FullTank from './Life Meters/FullTank.jsx'
import FoodTank from './Life Meters/FoodTank.jsx'

export default function S1LifeMeter({ score, isSleepSwitchOn, setIsSleepSwitchOn, setArrowPosition }) {

  return (
      <>
        <div className="life-meter-container">
          <div className="human-meter-row food-meter">
            <span className="human-meter-icon">🍽️</span>
            <FoodTank value={3.2} total={5} />
          </div>

          <div className="human-meter-row cycle-meter">
            <span className="human-meter-icon">{isSleepSwitchOn ? "☀️" : "🌙"}</span>
            <SleepSwitch isOn={isSleepSwitchOn} setIsOn={setIsSleepSwitchOn} />
          </div>
            
          <div className="human-meter-row temperature-meter">
            <span className="human-meter-icon">🌡️</span>
            <Temperature isSleeping={!isSleepSwitchOn} />
          </div>
          
          <div className="human-meter-row energy-meter">
            <span className="human-meter-icon">⚡</span>
            <FullTank value={3.2} total={5} />
          </div>
          
          <Mood setArrowPosition={setArrowPosition}/>
        </div>
      </>
    )
  }